interface Series {
  label: string;
  color: string;
  values: number[];
  /** Формат подписи максимума — чтобы у графика была шкала. */
  format?: (value: number) => string;
}

/**
 * Спарклайн на голом SVG. Библиотеку графиков не тянем: дашборду нужны линии
 * с общей осью времени, а не конструктор диаграмм.
 */
export function Chart({ series, height = 140 }: { series: Series[]; height?: number }) {
  const length = Math.max(...series.map((s) => s.values.length), 0);
  if (length < 2) {
    return <p className="muted">Недостаточно данных за выбранный период.</p>;
  }

  const width = 1000;
  const max = Math.max(1, ...series.flatMap((s) => s.values));
  const step = width / (length - 1);

  const path = (values: number[]) =>
    values
      .map((v, i) => `${i === 0 ? 'M' : 'L'} ${(i * step).toFixed(1)} ${(height - (v / max) * (height - 8) - 4).toFixed(1)}`)
      .join(' ');

  return (
    <div>
      <svg className="chart" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" role="img">
        {[0.25, 0.5, 0.75].map((f) => (
          <line
            key={f}
            x1={0}
            x2={width}
            y1={height * f}
            y2={height * f}
            stroke="currentColor"
            strokeOpacity={0.08}
            strokeWidth={1}
          />
        ))}
        {series.map((s) => (
          <path key={s.label} d={path(s.values)} fill="none" stroke={s.color} strokeWidth={2} vectorEffect="non-scaling-stroke" />
        ))}
      </svg>
      <div className="chart-legend">
        {series.map((s) => (
          <span key={s.label}>
            <i style={{ background: s.color }} />
            {s.label}
            {s.format ? ` · макс ${s.format(Math.max(...s.values))}` : ''}
          </span>
        ))}
      </div>
    </div>
  );
}
